import AoneService from "../axiosbase";
//get couriers
export const getCouriers = async (params) => {
    try {
      return await AoneService.get(`ops/api/v1/couriers${params}`);
    } catch (error) {
      return error;
    }
  };
  //get couriers version2
export const getCouriersV2 = async (params) => {
    try {
      return await AoneService.get(`ops/api/v2/couriers${params}`);
    } catch (error) {
      return error;
    }
  };
  export const getAllCouriers = async (params) => {
    try {
      return await AoneService.get(`ops/api/v1/couriers/all${params}`);
    } catch (error) {
      return error;
    }
  };
  //filter couriers
  export const filterCouriers = async (params) => {
    try {
      return await AoneService.get(`ops/api/v1/couriers/filter${params}`);
    } catch (error) {
      return error;
    }
  };
  //filter couriers version2
    export const filterCouriersV2 = async (params) => {
    try {
      return await AoneService.get(`ops/api/v2/couriers/filter${params}`);
    } catch (error) {
      return error;
    }
  };
//export couriers
export const exportCouriers = async (params) => {
    try {
      return await AoneService.get(`ops/api/v1/couriers/export${params}`, {
        responseType: "blob",
      });
    } catch (error) {
      return error;
    }
  };
//get task list for couriers
  export const getCourierTasks = async (params) => {
    try {
      return await AoneService.get(`ops/api/v1/couriers/tasks/${params}`);
    } catch (error) {
      return error;
    }
  };
//configure hubs to couriers
export const configureCourierHubs = async (params,data) => {
  try {
    return await AoneService.patch(`ops/api/v1/couriers/${params}/hub`,data);
  } catch (error) {
    return error;
  }
};
//export task list for couriers
  export const exportTasks = async (params) => {
    try {
      return await AoneService.get("ops/api/v1/couriers/tasks/export" + params, {
        responseType: "blob",
      });
    } catch (error) {
      return error;
    }
  };

  //status lookup
  export const getConsignmentStatus = async () => {
    try {
      return await AoneService.get(`ops/api/v1/lookups/CourierTaskStatus`);
    } catch (error) {
      return error;
    }
  };

  //tasktype lookup
  export const getConsignmentTaskType = async () => {
    try {
      return await AoneService.get(`ops/api/v1/lookups/CourierTaskType`);
    } catch (error) {
      return error;
    }
  };
  //assign courier as supplier
  export const assignSupplier = async (params,data) => {
    try {
      return await AoneService.patch(`ops/api/v1/couriers/employee/${params}/supplier`,data);
    } catch (error) {
      return error;
    }
  };
  //team leaders
  export const getTeamLeaders = async (params) => {
    try {
      return await AoneService.get(`ops/api/v1/team/leader${params}`);
    } catch (error) {
      return error;
    }
  };
  export const getTeamLeadersV2 = async (params) => {
    try {
      return await AoneService.get(`ops/api/v2/team/leader${params}`);
    } catch (error) {
      return error;
    }
  };
  //post
  export const postTeamLeaders = async (params) => {
    try {
      return await AoneService.post(`ops/api/v1/team/leader`,params);
    } catch (error) {
      return error;
    }
  };
  //put
  export const updateTeamLeaders = async (params,data) => {
    try {
      return await AoneService.put(`ops/api/v1/team/leader/${params}`,data);
    } catch (error) {
      return error;
    }
  };
  //delete
  export const deleteTeamLeaders = async (params) => {
    try {
      return await AoneService.delete(`ops/api/v1/team/leader/${params}`);
    } catch (error) {
      return error;
    }
  };
  //get couriers by team leader
  export const getCouriersByTeamLeader = async (params) => {
    try {
      return await AoneService.get(`ops/api/v1/team/leader/${params}/couriers`);
    } catch (error) {
      return error;
    }
  }
//export couriers by team leader
export const exportTeamLeader = async (params) => {
    try {
      return await AoneService.get(`ops/api/v1/team/leader/export${params}`, {
        responseType: "blob",
      });
    } catch (error) {
      return error;
    }
  };
  //get unassigned couriers
  export const getUnAssignedCouriers = async (params) => {
    try {
      return await AoneService.get(`ops/api/v1/couriers/unassigned/team-leader${params}`);
    } catch (error) {
      return error;
    }
  }
  //performance 
  //get performance
  export const getPerformance = async (params) => {
    try {
      return await AoneService.get(`ops/api/v1/couriers/performance/filter${params}`);
    } catch (error) {
      return error;
    }
  };
    export const getPerformanceV2 = async (params) => {
    try {
      return await AoneService.get(`ops/api/v2/couriers/performance/filter${params}`);
    } catch (error) {
      return error;
    }
  };
  //get performance by courier
  export const getPerformancebyCourier = async (params) => {
    try {
      return await AoneService.get(`ops/api/v1/couriers/performance/details/filter${params}`);
    } catch (error) {
      return error;
    }
  };
  //export performance
  export const exportPerformance = async (params) => {
    try {
      return await AoneService.get(`ops/api/v1/couriers/performance/export${params}`, {
        responseType: "blob",
      });
    } catch (error) {
      return error;
    }
  };
    export const exportPerformanceV2 = async (params) => {
    try {
      return await AoneService.get(`ops/api/v2/couriers/performance/export${params}`, {
        responseType: "blob",
      });
    } catch (error) {
      return error;
    }
  };
  //get couriers by groups
  export const getPerformancebyGroups = async (params) => {
    try {
      return await AoneService.get(`ops/api/v1/couriers/performance/groups${params}`);
    } catch (error) {
      return error;
    }
  };
  export const getPerformancebyGroupsV2 = async (params) => {
    try {
      return await AoneService.get(`ops/api/v2/couriers/performance/groups${params}`);
    } catch (error) {
      return error;
    }
  };
export const registerCourierInTGA = async (data) => {
  try {
    return await AoneService.post(`ops/api/v1/couriers/torood/register`, data);
  } catch (error) {
    return error;
  }
};
//Logout courier
  export const logoutUser = async (params) => {
    try {
      return await AoneService.post(`user-management/api/v1/logout/admin/${params}`);
    } catch (error) {
      return error;
    }
  };

  //courier performance service
      export const getCourierPerformance = async (params) => {
    try {
      return await AoneService.get(`dwh-cp/api/v1/courier/performance/filter${params}`);
    } catch (error) {
      return error;
    }
  };
   export const getCourierPerformancebyGroupsV2 = async (params) => {
    try {
      return await AoneService.get(`dwh-cp/api/v1/courier/performance/groups${params}`);
    } catch (error) {
      return error;
    }
  };
    export const getCourierPerformanceV2 = async (params) => {
    try {
      return await AoneService.get(`dwh-cp/api/v1/courier/performance/details/filter${params}`);
    } catch (error) {
      return error;
    }
  };
      export const exportCourierPerformanceV2 = async (params) => {
    try {
      return await AoneService.get(`dwh-cp/api/v1/courier/performance/export${params}`, {
        responseType: "blob",
      });
    } catch (error) {
      return error;
    }
  };
  //export not-yet-validated exception waybills
  export const exportNotValidatedPerformance = async (params) => {
    try {
      return await AoneService.get(`dwh-cp/api/v1/courier/performance/not-validated/export${params}`, {
        responseType: "blob",
      });
    } catch (error) {
      return error;
    }
  };
  //export detailed (waybill-level) courier performance
  export const exportCourierPerformanceDetails = async (params) => {
    try {
      return await AoneService.get(`dwh-cp/api/v1/courier/performance/details/export${params}`, {
        responseType: "blob",
      });
    } catch (error) {
      return error;
    }
  };
  //get latest TL validation history for a waybill
  export const getValidationLatest = async (trackingId) => {
    try {
      return await AoneService.get(`dwh-cp/api/v1/courier/performance/${trackingId}/validation-latest`);
    } catch (error) {
      return error;
    }
  };
  //sync team leader info for a courier
  export const syncTeamLeader = async (employeeCode) => {
    try {
      return await AoneService.get(`dwh-cp/api/v1/courier/performance/${employeeCode}/team-leader/sync`);
    } catch (error) {
      return error;
    }
  };
  //validation statistics (total exceptions, validation done, pending) for a courier
  export const getValidationStatistics = async (params) => {
    try {
      return await AoneService.get(`dwh-cp/api/v1/courier/performance/validation-statistics${params}`);
    } catch (error) {
      return error;
    }
  };
  //upload a single proof image (event code 4001) for a consignment; returns the stored image id in data.data
  export const uploadTLValidationProof = async (trackingId, formData) => {
    try {
      return await AoneService.post(
        `ops/api/v1/consignments/images/4001?trackingIdList=${trackingId}`,
        formData,
        { 'Content-Type': 'multipart/form-data' }
      );
    } catch (error) {
      return error;
    }
  };
  //submit a team-leader validation (remark, reschedule date, proof image ids) for a waybill
  export const submitTeamLeaderValidation = async (data) => {
    try {
      return await AoneService.post(`ops/api/v1/consignments/team-leader-validations`, data);
    } catch (error) {
      return error;
    }
  };
  //save the team leader note for a waybill (max 500 chars; a blank note clears it)
  export const saveTeamLeaderNote = async (data) => {
    try {
      return await AoneService.post(`dwh-cp/api/v1/courier/performance/team-leader-notes`, data);
    } catch (error) {
      return error;
    }
  };
  //TL validation remark lookup
  export const getTLValidationRemark = async () => {
    try {
      return await AoneService.get(`ops/api/v1/lookups/TLValidationRemark`);
    } catch (error) {
      return error;
    }
  };
  //record a feature-usage hit (deduped per 15 minutes per feature/employee)
  export const recordAnalyticsHit = async (data) => {
    try {
      return await AoneService.post(`analytics/api/v1/analytics/hits`, data);
    } catch (error) {
      return error;
    }
  };